import React from 'react'

const ClassCardSection6 = (props) => {
  return (
    <div>
    <img
      className="h-[15vh]  lg:w-[80%] lg:h-[30vh] rounded "
      src={props.image}
      alt=""
    />
  </div>
  )
}

export default ClassCardSection6